<template >
    <div class="big-container">
      <div class="container">
        <h1 class="text-titulo">Acesso Negado</h1>
        <span class="text-span"> Desculpe, você não possui as permissões necessárias para 
          acessar esta página. Por favor, entre em contato com o administrador do sistema 
          se acreditar que isso seja um erro ou se precisar de assistência adicional.
        </span>
        <button @click="$router.push('/esc-welcome')" class="input-button">Home</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data: () => ({
      overlay: false,
      descricao: null
    }),
  }
  </script>
  
  <style scoped>
  .big-container {
      height: 100%;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(196, 195, 195, 0.5);
  }
  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60%;
    background-color: #fff;
    border: 0.1px solid #c2c2dd;
    padding: 20px;
    font-size: 12px;
    font-family: sans-serif;
  }
  
  .text-titulo {
    font-size: 18px;
    text-align: center;
    text-transform: uppercase;
    color: #f93939;
  }
  
  .text-span {
    font-size: 14px;
    display: block;
    text-align: justify;
  }
  
  .input-button {
    width: 15%;
    display: block;
    margin: 10px auto 0;
    background-color: #8c8cf5;
    padding: 10px;
    border-radius: 5px;
    color: #fff;
    font-weight: bold;
    transition: all 0.5s;
  }
  
  .input-button:hover {
    transition: all 0.5s;
    width: 17%;
  }
  </style>